module.exports = __webpack_public_path__ + "img/insta.61d6e15c.jpg";